import script from "./FormProspectoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormProspectoComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormProspectoComponent.vue?vue&type=style&index=0&id=190921d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-190921d5"]])

export default __exports__